module.exports = __webpack_public_path__ + "static/fast-breadcrumb-custom-1424266e057a9636afb67c961399c85b.png";